'use strict';

class LoyaltyLanding {
    init () {
        this.slickCarouselAdvantages();
        this.loyaltyCardsSlider();
    }

    slickCarouselAdvantages () {
        $('.card-container').slick({
            slidesToShow: 4,
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: false,
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '100px',
                    initialSlide: 1
                }
            }]
        });
    }

    initHorizontalSlider (containerSelector, leftBtnSelector, rightBtnSelector, cardSelector) {
        const container = document.querySelector(containerSelector);
        const leftBtn = document.querySelector(leftBtnSelector);
        const rightBtn = document.querySelector(rightBtnSelector);

        if (!container || !leftBtn || !rightBtn) return;

        function updateArrows () {
            const isScrollable = container.scrollWidth - container.offsetWidth > 1;
            const parent = leftBtn.parentElement;
            if (parent) {
                parent.classList.toggle('d-none', !isScrollable);
            }
            leftBtn.classList.toggle('disabled', !isScrollable || container.scrollLeft <= 5);
            rightBtn.classList.toggle('disabled', !isScrollable || container.scrollLeft + container.offsetWidth >= container.scrollWidth - 5);
        }

        leftBtn.addEventListener('click', function () {
            var card = container.querySelector(cardSelector);
            if (card) {
                container.scrollLeft -= card.offsetWidth;
            }
        });

        rightBtn.addEventListener('click', function () {
            var card = container.querySelector(cardSelector);
            if (card) {
                container.scrollLeft += card.offsetWidth;
            }
        });

        container.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        updateArrows();
        setTimeout(updateArrows, 500);
    }

    loyaltyCardsSlider () {
        this.initHorizontalSlider('.loyalty-cards-container', '.loyalty-cards-list-arrows-left', '.loyalty-cards-list-arrows-right', '.loyalty-card-wrp');
    }
}

var loyaltyLanding = new LoyaltyLanding();
document.addEventListener('DOMContentLoaded', () => {
    loyaltyLanding.init();
});
